module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      background: _vm.background,
      backgroundSize: 'cover',
      height: '100vh',
      width: '100vw',
      position: 'fixed'
    }),
    attrs: {
      "id": "login-bg"
    }
  }, [_c('div', {
    attrs: {
      "id": "login-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "login-form"
    }
  }, [_c('form', {
    staticClass: "right-sided"
  }, [_c('img', {
    staticClass: "company-logo",
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "company-logo"
    }
  }), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger error-message"
  }, [_vm._v("\n          " + _vm._s(_vm.errorMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.passwordReset) ? _c('password-reset') : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.resetPassword.apply(null, arguments)
      }
    }
  }, [_vm._v("Forgotten your password?")])]), _vm._v(" "), _c('button', {
    class: [_vm.isBot ? 'disabled' : '', 'btn btn-primary'],
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Let's go")])]), _vm._v(" "), _c('p', {
    staticClass: "text-center mt10"
  }, [_vm._v("Powered by MoveAssist")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee668ae6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 2292
// module chunks = 1